import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/common/services/api.service';
import { UtilService } from 'src/app/util/util.service';
import { ALLOWED_PLATFORM_CONFIG_IDS } from 'src/app/order/platform.constant';
import { CurrencyService } from 'src/app/util/currency.service';
import { FormaterService } from '../../services/formater.service';
import { LanguageService } from '../../services/language.service';
import { country } from 'src/app/common/enums/language';
import { MessageService } from '../../services/message.service';
import { LocalStorageService } from '../../services/localStorage.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PaymentMethod } from '../../../common/enums/payment';
import { CHECKED } from 'src/defaultImages.js';
import { PineLabService } from '../../services/pine-lab.service';

@Component({
  selector: 'app-payment-options',
  templateUrl: './payment-options.component.html',
  styleUrls: ['./payment-options.component.css'],
})
export class PaymentOptionsComponent implements OnInit, OnChanges {
  images = { 
    CHECKED: CHECKED,
  };
  Currency;
  paymentAmount;
  paymentMethod: any;
  PAYMENT_METHOD_ENUMS = PaymentMethod
  selectedPaymentMethod: string = '';
  transaction_id: string = '';
  recommendationArray = [];
  billBalance: any;
  amountToReturn: any;
  num;
  balanceStatus: boolean = false;
  show: boolean = false;
  isLoading: boolean = false;
  paidAmount: number;
  suggestion1: number;
  suggestion2: number;
  currentAmount: number;
  customCashInput: boolean = false;
  @Input() amount: number;
  @Input() platform: string;
  @Input() paymentInputDisabled: boolean = false;
  @Input() showUnionExperience: boolean = false;
  @Input() showQris: boolean = true;
  @Input() showDuitnow: boolean = true;
  @Input() showPineLab: boolean = true;
  @Output() name = new EventEmitter();
  @Output() channel = new EventEmitter();
  @Output() t_id = new EventEmitter();
  @Output() amount_paid = new EventEmitter();
  @Output() cashDetails = new EventEmitter();
  unionExperienceForm: FormGroup;
  currentDomain;
  inputMaskConfig = {
    mask: 'separator.2',
    thousandSeparator: ',',
  };

  cashData: any;
  canCollectCash: boolean = false;
  translationText: any;
  subscription = new Subscription();
  @Input() isFCChangePaymentMethod: number = 0;
  @Input() orderId:string = "";
  @Input() fcOrderPayments: any = [];
  @Input() mergedOrderIds: any[] = [];
  isAllfcOrderPaymentRemoved: boolean = false;

  constructor(
    private utilService: UtilService,
    public apiService: ApiService,
    private _fb: FormBuilder,
    private curr: CurrencyService,
    public format: FormaterService,
    private languageService: LanguageService,
    private messageService: MessageService,
    private _localStorage: LocalStorageService,
    private translateService: TranslateService,
    private _pineLabService: PineLabService
  ) {
    this.Currency = this.curr.getCurrency();
    this.currentDomain = this.languageService.getDomain();
  }
  getAllPaymentMethods() {
    this.isLoading = true;
    const formData: any = new FormData();
    const kiosk = this.utilService.isKiosk();
    formData.append('restaurant_id', this._localStorage.get('restaurant_id'));
    formData.append('platform', 'partner');
    if (kiosk) {
      formData.append('fc_order_id', this.orderId);
    } else if (this.mergedOrderIds && this.mergedOrderIds.length > 0) {
      formData.append('all_orders', this.mergedOrderIds);
    }  
    this.apiService.getPaymentMethods(formData).subscribe((res: any) => {
      if (res.status) {
        this.paymentMethod = this.utilService.mergeTerminalPaymentGroup(res.data);
        this.paymentMethod = this.utilService.parsePaymentMethod(
          this.paymentMethod,
          localStorage.getItem('pos_platform')
        );
      } else {
        this.paymentMethod = [];
      }
      // this.selectedPaymentMethod = this.paymentMethod[0].id;
      // this.selectedMethod(this.paymentMethod[0]);

      this.paymentMethod = this.utilService.filterPaymentMethod(
        this.paymentMethod,
        this.platform
      );
      this.isLoading = false;
    });
  }
  ngOnInit() {
    this.getAllPaymentMethods();
    this.subscription.add(this.translateService.get(['SETTLE_BILL']).subscribe((translation) => {
      this.translationText = translation.SETTLE_BILL;
    }));
    this.getCashRegistryInfo();
    this.inputMaskConfig = {
      mask: country[this.currentDomain].mask,
      thousandSeparator: country[this.currentDomain].thousandSeparator,
    };
    this.unionExperienceForm = this._fb.group({
      amount: [null, Validators.required],
      txn_id: [null, Validators.required],
    });
    this.paymentAmount = this.format.formatNo(this.billBalance);
    this.amount_paid.emit(this.paymentAmount);
    this.suggestion1 = localStorage.getItem('language') === 'en_US' ? 50 : 500;
    this.suggestion2 =
      localStorage.getItem('language') === 'en_US' ? 100 : 1000;
    this.fcOrderPayments = this.fcOrderPayments?.map(paymentObj=>({...paymentObj, isRemoved:false})); 
  }
  ngOnChanges() {
    if (typeof this.amount == 'number') {
      this.show = true;
      this.getAmountSuggestion(this.amount);
    }
    this.paymentAmount = this.format.formatNo(
      Math.round(this.billBalance * 100) / 100
    );
    this.amount_paid.emit(this.paymentAmount);
  }

  getCashRegistryInfo() {
    const restId = this._localStorage.get('restaurant_id');
    const deviceId =  this.utilService.getDeviceUID();
    this.apiService.getCashRegisterAnalytics(restId, deviceId).subscribe((response) => {
      if ((response || {}).statusCode === 200) {
        this.cashData = (response || {}).data;
      }
    });
  }

  isPineLabsCardDisabled(item: any): boolean {
    return this.utilService.isPineLabsPaymentCardUiDisabled(item);
  }

  onPineLabsUnavailableInfoClick(event: MouseEvent): void {
    event.stopPropagation();
    this._pineLabService.showPineLabsServiceUnavailableModal();
  }

  selectedMethod(item) {
    if (this.isPineLabsCardDisabled(item)) {
      return;
    }
    if(this.isFCChangePaymentMethod && !this.isAllfcOrderPaymentRemoved ){
      this.messageService.showError(
        this.translationText.DELETE_PREV_PMT_METHOD
        );
      return;
    }
    this.selectedPaymentMethod = item.id;
    this.show = true;
    if ([PaymentMethod.doku_qris,PaymentMethod.duitnow,PaymentMethod.PINE_LABS].includes(this.selectedPaymentMethod)) {
      this.show = false;
    }
    if (this.utilService.cashRegistryEnabled() && this.selectedPaymentMethod === PaymentMethod.pos_cash) {
      if (this.cashData['active-epoch'] !== null) {
        this.canCollectCash = true;
        this.transaction_id = '';
        if (typeof this.amount === 'number') {
          this.getAmountSuggestion(this.amount);
        }
      } else {
        this.canCollectCash = false;
        this.messageService.showError(
          this.translationText.CASH_IS_CLOSED_TO_ACCEPT_CASH_OPEN_CASHIER_FIRST
          );
      }
    }
    if (this.selectedPaymentMethod === PaymentMethod.union_experience_voucher) {
      this.unionExperienceForm
        .get('amount')
        .setValidators([Validators.required]);
      this.unionExperienceForm
        .get('txn_id')
        .setValidators([Validators.required]);
    } else if (
      ALLOWED_PLATFORM_CONFIG_IDS.includes(this.selectedPaymentMethod)
    ) {
      this.unionExperienceForm
        .get('amount')
        .setValidators([Validators.required]);
      this.unionExperienceForm.get('txn_id').clearValidators();
    } else {
      this.unionExperienceForm.get('amount').clearValidators();
      this.unionExperienceForm.get('txn_id').clearValidators();
    }
    this.unionExperienceForm.updateValueAndValidity();
    if (this.selectedPaymentMethod === PaymentMethod.pos_cash && !this.canCollectCash) {
      this.name.emit(null);
      this.channel.emit(null);
      this.t_id.emit(null);
      this.amount_paid.emit(null);
    } else {
      this.name.emit(item.name);
      this.channel.emit(item.channel);
      this.t_id.emit(this.transaction_id);
      this.amount_paid.emit(this.paymentAmount);
    }
  }
  returnPositive(num) {
    if (typeof num === 'string') {
      if (num && num.toString().charAt(0) === '-') {
        return num.substring(1);
      } else return num;
    }
    if (num >= 0) {
      return num;
    } else return -num;
  }
  changes(e) {
    return e.charCode >= 44;
  }
  onChange(e) {
    this.t_id.emit(this.transaction_id);
  }
  onChangeAmount(e) {
    const currPaymentAmt = e;
    this.amount_paid.emit(this.format.formatNo(this.paymentAmount));
    this.cashDetails.emit({
      collected_amt: this.format.formatNo(currPaymentAmt),
      returned_amt: this.format.formatNo(currPaymentAmt - this.billBalance),
    });
  }
  clearInput() {
    this.paymentAmount = '';
    this.amount_paid.emit(this.paymentAmount);
  }

  getAmountSuggestion(amount) {
    this.recommendationArray = [];
    this.billBalance = amount;
    const remainder = amount % this.suggestion2;
    if (remainder >= this.suggestion1) {
      const x = amount + (this.suggestion2 - remainder);
      this.recommendationArray.push(
        this.format.formatNo(amount),
        this.format.formatNo(x)
      );
    } else {
      const x = amount + (this.suggestion2 - remainder);
      const y = x - this.suggestion1;
      this.recommendationArray.push(
        this.format.formatNo(amount),
        this.format.formatNo(y),
        this.format.formatNo(x)
      );
    }

    this.currentAmount = this.recommendationArray[0];
    this.getButtonPrice(this.currentAmount);
  }

  getButtonPrice(price, cashInput: boolean = false) {
    this.customCashInput = cashInput;
    this.paidAmount = null;
    this.currentAmount = price;
    this.balanceStatus = true;
    if (this.format.formatMy(price) > 0) {
      this.num = this.format.formatMy(price) - this.billBalance;
      this.amountToReturn = this.format.formatNo(this.num);
    } else {
      this.num = 0;
      this.amountToReturn = this.format.formatNo(this.billBalance);
    }
    this.cashDetails.emit({
      collected_amt: price,
      returned_amt: this.amountToReturn,
    });
  }
  valueChanges(e) {
    if (e.target.value !== '') {
      this.num = +this.format.formatMy(e.target.value) - this.billBalance;
      this.amountToReturn = this.format.formatNo(this.num);
      this.balanceStatus = true;
      this.cashDetails.emit({
        collected_amt: e.target.value,
        returned_amt: this.amountToReturn,
      });
    } else {
      this.num = 0;
      this.amountToReturn = this.format.formatNo(this.billBalance);
      this.balanceStatus = true;
    }
  }
  numChanges(e) {
    return e.charCode >= 44 && e.charCode <= 57 && e.charCode !== 47;
  }

  isVoucherPlatformValid(config_id) {
    return ALLOWED_PLATFORM_CONFIG_IDS.includes(config_id);
  }

  alphaNumberOnly(e) {
    let regex = new RegExp('^[a-zA-Z0-9,. ]+$');
    let str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }
    e.preventDefault();
    return false;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  removePaymentMethod(index: number): void {
      if(this.fcOrderPayments[index] && this.fcOrderPayments[index].hasOwnProperty('isRemoved')){
      this.fcOrderPayments[index].isRemoved = true;
      this.isAllfcOrderPaymentRemoved = this.fcOrderPayments.every(e=>e.isRemoved == true);
    }
  }

  trackById(item: any): number {
    return item.payment_id;
  }
}
